<template>
  <div id="app">
    <header>
      <b-navbar toggleable="md" variant="dark" type="dark">
        <b-navbar-brand to="/" active-class="active"
          >Unmatched Maker</b-navbar-brand
        >

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'DeckList' }"
              exact
              exact-active-class="active"
              >Fan decks</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'CreateDeck' }"
              exact
              exact-active-class="active"
              >Create deck</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'TrackGame' }" active-class="active"
              >Track game</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'ResultsGrid' }" active-class="active"
              >View results</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'UmDb' }" active-class="active"
              >UmDb</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'Resources' }"
              exact
              exact-active-class="active"
              >Resources</b-nav-item
            >
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <template v-if="userProfile">
              <!--              <b-nav-item
                :to="{
                  name: 'UserDeckList',
                  params: { username: userProfile.username }
                }"
                exact
                exact-active-class="active"
                >My decks</b-nav-item
              >
              <b-nav-item
                :to="{
                  name: 'UserResultsGrid',
                  params: { username: userProfile.username }
                }"
                exact
                exact-active-class="active"
                >My games</b-nav-item
              > -->
              <b-nav-item-dropdown right :text="userProfile.username">
                <b-dropdown-item
                  :to="{
                    name: 'UserDeckList',
                    params: { username: userProfile.username },
                  }"
                  >My decks</b-dropdown-item
                >
                <b-dropdown-item
                  :to="{
                    name: 'UserResultsGrid',
                    params: { username: userProfile.username },
                  }"
                  >My games</b-dropdown-item
                >
                <b-dropdown-divider />
                <b-dropdown-item @click="logout"> Log out </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>
            <b-nav-item v-else to="/login">Log in</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <main class="main-content">
      <b-container class="pt-2 pt-md-3">
        <router-view />
      </b-container>
    </main>
    <footer class="no-print">
      <div class="container py-4">
        <span class="text-muted">
          <strong
            >This site is not in any way affiliated with Restoration Games or
            Mondo Games.</strong
          >
          The look and design of Unmatched cards is a trademark of Restoration
          Games, LLC and is used with permission. Decks using this design may
          not be used for commercial purposes.
        </span>
      </div>
      <b-navbar
        toggleable="sm"
        class="um-footer justify-content-center"
        type="auto"
      >
        <b-collapse is-nav class="justify-content-center show d-block">
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'SupportTheSite' }"
              exact
              exact-active-class="active"
              >Support the site</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'Contact' }"
              exact
              exact-active-class="active"
              >Contact</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              href="https://github.com/JonathanGuberman/unmatched_maker/issues"
              target="_blank"
              exact
              exact-active-class="active"
              >Bugs</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'ReportAbuse' }"
              exact
              exact-active-class="active"
              >Report abuse</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'PrivacyPolicy' }"
              exact
              exact-active-class="active"
              >Privacy</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-item
              :to="{ name: 'Terms' }"
              exact
              exact-active-class="active"
              >Terms</b-nav-item
            >
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </footer>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "App",
  metaInfo: {
    title: "",
    titleTemplate: "%s | Unmatched Maker",
  },
  computed: {
    userProfile() {
      return this.$store.state.userProfile;
    },
  },
  methods: {
    async logout() {
      try {
        await api.logout();
        this.$router.go();
        this.$root.$bvToast.toast("Come back soon!", {
          title: "Logged out",
          variant: "success",
        });
      } catch (error) {
        this.$root.$bvToast.toast("Uh oh.", {
          title: "Problem logging out",
          variant: "danger",
        });
      }
    },
  },
};
</script>

<style lang="less">
#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

blockquote {
  background: rgba(0, 0, 0, 0.03);
  @media (prefers-color-scheme: dark) {
    background: rgba(255, 255, 255, 0.03);
    border-left: 0.25rem solid #444;
  }
  border-left: 0.25rem solid #ccc;
  margin: 1.5rem 1rem;
  padding: 0.5rem 1rem;
  quotes: "\201C""\201D""\2018""\2019";
}
// blockquote:before {
//   color: #ccc;
//   content: open-quote;
//   font-size: 4em;
//   line-height: 0.1em;
//   margin-right: 0.25em;
//   vertical-align: -0.4em;
// }
blockquote p {
  display: inline;
}

.main-content {
  flex: 1;
}

.print {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  z-index: -9999;
}
@media print {
  * {
    -webkit-transition: none !important;
    transition: none !important;
  }

  .no-print {
    display: none !important;
  }

  .print {
    opacity: 1;
    display: block !important;

    .unmatched-card {
      float: left;
      margin: 0;
      page-break-inside: avoid;
    }
  }

  .print.card-borders .unmatched-card {
    border: 1px solid rgba(0, 0, 0);
  }

  .print.crop-marks .unmatched-card {
    &:before,
    &:after {
      position: absolute;
      content: "";
      border: solid black;
      z-index: -1;
    }
    &:before {
      top: -32px;
      bottom: -32px;
      left: 0;
      right: 0;
      border-width: 0 1px;
    }
    &:after {
      left: -32px;
      right: -32px;
      top: 0;
      bottom: 0;
      border-width: 1px 0;
    }
  }

  .print.crop-marks.card-borders .unmatched-card {
    &:before {
      left: -1px;
      right: -1px;
    }
    &:after {
      top: -1px;
      bottom: -1px;
    }
  }
}
</style>
